import { useState } from "react";
import { useForm } from "../../hooks/useForm";
import InfoTooltip from "../layout/InfoTooltip";
import { MATERIALS_LIMITS } from "../../utils/constants";

export default function MaterialsTextarea() {
  const { showMaterials, materialsText, toggleMaterials, setMaterials } =
    useForm();
  const [isFocused, setIsFocused] = useState(false);

  const charCount = materialsText.length;
  const lineCount = materialsText.split("\n").length;
  const isOverCharLimit = charCount > MATERIALS_LIMITS.maxChars;
  const isOverLineLimit = lineCount > MATERIALS_LIMITS.maxLines;

  return (
    <div className="mt-4">
      {showMaterials && (
        <>
          <h2 className="text-md font-semibold mb-2">
            Materials
            <InfoTooltip>
              In this open field, you must write in detail all materials that
              will be used to build your structure. This can include: Structure
              type: Ex. treated wood, metal, vinyl, etc. Base: Concrete blocks,
              slabs, blocks, wood base, etc. Exterior finishes: Paint, siding,
              roofing, etc. This listing will be included in the final PDF to
              validate compliance with local regulations.
            </InfoTooltip>
          </h2>
          <div className="mt-4 mb-3">
            <textarea
              value={materialsText}
              onChange={(e) => setMaterials(e.target.value)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              placeholder="Enter materials information (max 510 characters)..."
              rows={12}
              className={`w-full md:w-4/5 rounded px-2 py-1 resize-y ${
                (isOverCharLimit || isOverLineLimit) && isFocused
                  ? "border-4 border-red-500"
                  : isOverCharLimit || isOverLineLimit
                    ? "border-2 border-red-500"
                    : "border border-gray-300"
              }`}
            />
            <div className="text-sm text-gray-500 mt-1 flex flex-col md:flex-row md:justify-center md:gap-4">
              <span>
                <span className={isOverCharLimit ? "text-red-500 font-semibold" : ""}>
                  {charCount}
                </span>
                /{MATERIALS_LIMITS.maxChars} characters
                {isOverCharLimit && (
                  <span className="ml-1 text-red-500 font-semibold">
                    — {charCount - MATERIALS_LIMITS.maxChars} over limit
                  </span>
                )}
              </span>
              <span>
                <span className={isOverLineLimit ? "text-red-500 font-semibold" : ""}>
                  {lineCount}
                </span>
                /{MATERIALS_LIMITS.maxLines} lines
                {isOverLineLimit && (
                  <span className="ml-1 text-red-500 font-semibold">
                    — {lineCount - MATERIALS_LIMITS.maxLines} over limit
                  </span>
                )}
              </span>
            </div>
          </div>
        </>
      )}

      <button
        type="button"
        onClick={toggleMaterials}
        className="bg-[#2f5241] hover:bg-[#2f5241e1] text-white px-5 py-2 rounded mt-2 hover:cursor-pointer"
      >
        {showMaterials ? "Hide materials" : "Add materials"}
      </button>
    </div>
  );
}
